// Typebox format registration. Typebox does not ship format validators out of
// the box — Value.Check silently passes unknown formats. We register the ones
// our schemas actually use, so validation is strict everywhere (SDK, API, tests).
// Importing this module is a side-effect; the shared package barrel does it
// exactly once, at module load.
import { FormatRegistry } from '@sinclair/typebox';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
// RFC 3339 date-time. Accepts both `Z` and `±HH:MM` offsets, optional fractional seconds.
const DATE_TIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;
FormatRegistry.Set('uuid', (v) => typeof v === 'string' && UUID_RE.test(v));
FormatRegistry.Set('date-time', (v) => typeof v === 'string' && DATE_TIME_RE.test(v));
//# sourceMappingURL=formats.js.map